import { Children, cloneElement } from 'react';

import { useIsActiveRoute } from '@larvitu/shared/next/utils';

import type { FC, ReactElement } from 'react';

export interface ActiveRouteControllerProps {
  // eslint-disable-next-line @typescript-eslint/ban-types
  path: string & {};
  children: ReactElement<{ active: boolean }>;
}

export const ActiveRouteController: FC<ActiveRouteControllerProps> = ({
  path = '',
  children,
  ...props
}) => {
  const { isActive } = useIsActiveRoute( path );

  return (
    <>
      {Children.map( children, (child) =>
        cloneElement( child, { ...isActive && { active: true }, ...props } ) )}
    </>
  );
};
